class ExpirePassword {
    constructor() {
        this.expirePasswordFormValidation();
    }

}
window.ExpirePassword = ExpirePassword;